import { forwardRef } from "react";
import { TextField as DovaTextField, type TextFieldProps } from "@codel/dova-ds";

/**
 * The couple app's text field: the DS `TextField` with the typed text one step up,
 * 18px (--type-body-lg's size) instead of the DS default 16px.
 *
 * Couples answer on their phones, and in these flows the answer is the point of the
 * screen, so it reads at body-lg. Anything ≥16px also keeps iOS Safari from zooming
 * in on focus. The DS default stays 16px for the therapist portal's denser forms.
 *
 * Use this, not the DS `TextField`, anywhere under /me, so the next field added gets
 * the same size without anyone remembering to ask for it. `!` because the DS field's
 * own `text-base` sits in the same class list; a caller's `className` is kept.
 */
export const TextField = forwardRef<HTMLInputElement | HTMLTextAreaElement, TextFieldProps>(
  function TextField({ className, ...props }, ref) {
    return (
      <DovaTextField
        ref={ref}
        {...(props as TextFieldProps)}
        className={["text-lg!", className].filter(Boolean).join(" ")}
      />
    );
  }
);
